import "./bootstrap";
import "../css/app.css";
//import 'flowbite-vue/dist/index.css';
import "@bhplugin/vue3-datatable/dist/style.css";
import "@vueform/multiselect/themes/default.css";
import * as Sentry from "@sentry/vue";
// import 'vue3-perfect-scrollbar/style.css';
// import base from './Mixins/base';

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";

// import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { OhVueIcon, addIcons } from "oh-vue-icons";
import Vueform from "@vueform/vueform";
import vueformConfig from "./../../vueform.config";
import { ref } from "vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import DataTable from "datatables.net-vue3";
import "@bhplugin/vue3-datatable/dist/style.css";
import {
    HiBriefcase,
    BiPeople,
    BiArrowRightShort,
    BiArrowLeftShort,
    BiCheckSquare,
    FaRegularEdit,
    HiMail,
    HiCheckCircle,
    HiXCircle,
    HiCalendar,
} from "oh-vue-icons/icons";

addIcons(
    HiBriefcase,
    BiPeople,
    BiArrowRightShort,
    BiArrowLeftShort,
    BiCheckSquare,
    FaRegularEdit,
    HiMail,
    HiCheckCircle,
    HiXCircle,
    HiCalendar
);

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        if (import.meta.env.APP_ENV != "local") {
            Sentry.init({
                app,
                dsn: "https://71d9b4ce5426d31b7c62f516210e8778@o4508314049511424.ingest.de.sentry.io/4510243938566224",
                integrations: [
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                    }),
                ],
                // Session Replay
                replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
                sendDefaultPii: true,
            });
        }
        app.use(plugin)
            // .use(PerfectScrollbarPlugin)
            .use(ZiggyVue)
            .use(Vueform, vueformConfig)
            // .mixin(base)
            .component("v-icon", OhVueIcon)
            .mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
